import { render, staticRenderFns } from "./Configstable.vue?vue&type=template&id=60a366fe&"
import script from "./Configstable.vue?vue&type=script&lang=js&"
export * from "./Configstable.vue?vue&type=script&lang=js&"
import style0 from "./Configstable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports